<template>
<div class="data-static">
	<div v-if="deptType == 0" style="height: 60px;">
		<!-- deptType == 0，表示管理员 -->
		<a-select v-model="currentCompany" allowClear style="width: 300px;" placeholder="全部" @change="selectCompany">
			<a-select-option v-for="i in companyList" :key="i.id">{{i.name}}</a-select-option>
		</a-select>
	</div>
	<div class="select-box">
		<div>
			<span >统计年份</span>
			<a-select v-model="currentYear" style="width: 100px; margin-left: 20px; padding: 0;" placeholder="统计年份" @change="selectTime">
				<a-select-option v-for="d in timeList" :key="d">{{d}}</a-select-option>
			</a-select>
		</div>
		<div>
			<span>订单分类统计</span>
		</div>
	</div>
	<div class="top">
		<div class="top-left">
			<div class="top-bot">
				<div class="left">
					<div class="list">
						<p>充值总金额</p>
						<p>{{companyInfo.allMoney?companyInfo.allMoney.toFixed(2):0}}</p>
					</div>
					<div class="list">
						<p>总充值积分</p>
						<p>{{companyInfo.allPoints?companyInfo.allPoints.toFixed(2):0}}</p>
					</div>
				</div>
				<div class="right">
					<div class="list">
						<p>已为您节约</p>
						<p>{{companyInfo.save?companyInfo.save.toFixed(2):0}}</p>
						<p>（{{companyInfo.scale}}）</p>
					</div>
				</div>
			</div>
		</div>
		<div class="top-right">
			<div id="myChart" style="width: 100%;height: 100%"></div>
		</div>
	</div>
	<div class="bottom">
		<div class="left">
			<div class="til">
				<p><span>订单数据统计</span></p>
				<p>
					<a-select v-model="currentLab" allowClear style="width: 200px;" placeholder="筛选实验室" @change="selectLab">
						<a-select-option v-for="i in labList" :key="i.id">{{i.name}}</a-select-option>
					</a-select>
					<a-select v-model="options" style="width: 100px; margin-left: 20px;" placeholder="筛选类型" @change="selectLab">
						<a-select-option :value="1">订单数</a-select-option>
						<a-select-option :value="2">报告数</a-select-option>
						<a-select-option :value="3">积分数</a-select-option>
					</a-select>
				</p>
				
			</div>
			<div id="myChart1" style="width: 100%;height: 500px"></div>
		</div>
		<div class="right">
			<p class="til">
				<span>实验室数据统计</span> 
				<a-select v-model="currentSort" style="width: 150px;" placeholder="排序方式" @change="selectSort">
					<a-select-option v-for="i in sortList" :key="i.id">{{i.name}}</a-select-option>
				</a-select>
			</p>
			<div id="myChart2" style="width: 100%;height: 500px"></div>
		</div>
	</div>
</div>
</template>

<script>
import {getYear, getEnterpriseClass, getOrderDataStatic, getLabDataStatic, getCompanyUserStatic, getCompanyList, getLabList } from '@/api/static'
import {formatDate} from '@/utils/date';

export default {
  components: {},
  data() {
    return {
     timeList: [],
			currentYear: '2021',
			companyInfo: {},
			companyList: [],
			labList: [],
			currentLab: undefined,
			currentCompany: undefined,
			currentSort: 0,
			deptType: null,
			options: 1,
			sortList: [{'id': 0, 'name': '按订单数排序'}, {'id': 1, 'name': '按订单积分总额排序'}, {'id': 2, 'name': '按报告交付平均用时排序'}, {'id': 3, 'name': '按报告交付准时率排序'},]
    };
  },
  created() {
    let userMsg = this.$store.state.user.user;
    this.roles = userMsg.roles;
		let deptType = this.$store.state.user.user.deptType;
    this.deptType = deptType;
		this.getCompanyList();
		this.getLabList();
  },
  mounted() {
		this.getYear();
  },
  methods: {
	  selectTime() {
		  this.dataRefresh();
	  },
	  getYear() {
		  getYear()
		  	.then(res => {
					this.timeList = res;
					this.currentYear = res[0];
					this.dataRefresh();
				})
				.catch(error => {
					console.log(error);
				})
	  },
		dataRefresh() {
			let params = {
				'id': this.currentCompany,
				'year': this.currentYear,
				'sort': this.currentSort,
				'options': this.options,
				'labId': this.currentLab
			}
			this.getEnterpriseClass(params);
			this.getOrderDataStatic(params);
			this.getLabDataStatic(params);
			this.getCompanyUserStatic(params);
		},
		// 查询实验室
	  selectLab() {
			let params = {
				'id': this.currentCompany,
				'year': this.currentYear,
				'sort': this.currentSort,
				'options': this.options,
				'labId': this.currentLab
			}
			this.getOrderDataStatic(params);
	  },
		// 选择实验室
	  selectSort() {
			let labData = {
				'id': this.currentCompany,
				'year': this.currentYear,
				'sort': this.currentSort,
				'options': this.options,
				'labId': this.currentLab
			}
			this.getLabDataStatic(labData);
	  },
		// 选择企业
	  selectCompany() {
		  this.dataRefresh();
	  },
		// 获取企业列表
	  getCompanyList() {
		   getCompanyList()
		  	.then(res => {
				this.companyList = res;
			})
			.catch(error => {
				console.log(error);
			})
	  },
		// 获取实验室列表
	  getLabList() {
		  getLabList()
		  	.then(res => {
				this.labList = res;
			})
			.catch(error => {
				console.log(error);
			})
	  },
		// 订单分类
	  getEnterpriseClass(params) {
		  getEnterpriseClass(params)
		  	.then(res => {
				if (res) {
					this.init(res.legend, res.series, res.data);
				}
			})
			.catch(error => {
				console.log(error);
			})
	  },
		// 订单数据统计
	  getOrderDataStatic(params) {
		  getOrderDataStatic(params)
		  	.then(res => {
				if (res) {
					// console.log('订单: 000', res);
					this.initOrderData(res.legend, res.series, res.xaxis);
				}
			})
			.catch(error => {
				console.log(error);
			})
	  },
		// 实验室数据统计
	  getLabDataStatic(params) {
		  getLabDataStatic(params)
		  	.then(res => {
				if (res) {
					this.initLabData(res.legend, res.series, res.data);
				}
			})
			.catch(error => {
				console.log(error);
			})
	  },
	  getCompanyUserStatic(params) {
			// console.log(params);
		  getCompanyUserStatic(params)
		  	.then(res => {
				this.companyInfo = res;
			})
			.catch(error => {
				console.log(error);
			})
	  },
		// 订单分类统计
	  init(legend, series, data) {
		  let myChart = this.$echarts.init(document.getElementById('myChart'));
		  let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				color:['#91CB74', '#73C0DE', '#ffa500'],
				legend: {
					data: legend
				},
				yAxis: {
					type: 'value',
					boundaryGap: [0, 0.01]
				},
				xAxis: {
					type: 'category',
					data: data
				},
				series: series
		};
		myChart.setOption(option)
	  },
		// 实验室数据
	  initLabData(legend, series, data) {
		  let myChart = this.$echarts.init(document.getElementById('myChart2'));
		  let option = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					}
				},
				grid: {
					left: '3%',
					right: '4%',
					bottom: '3%',
					containLabel: true
				},
				// legend: {
				// 	data: legend
				// 	// legend 中的值需要与 series 中的 name 一致，才能显示
				// },
				color:['#91CB74', '#73C0DE', '#FAC858', '#FFA3A3'],
				xAxis: {
					type: 'value',
					
				},
				yAxis: {
					type: 'category',
					data: data
				},
				series: series
		};
		myChart.setOption(option)
	  },
		// 订单数据
	  initOrderData(legend, series, data) {
			// console.log('实验室数据：',legend, series, data);
		  let myChart = this.$echarts.init(document.getElementById('myChart1'));
		  let option = {
			
			tooltip: {
				trigger: 'axis'
			},
			xAxis: {
				type: 'category',
				boundaryGap: false,
				data: data
			},
			yAxis: {
				type: 'value'
			},
			series: series
		};
		myChart.setOption(option)
	  },
  },
  watch: {
   
  },
  filters: {
    formatDate(time) {
      var date = new Date(time);
      return formatDate(date, "yyyy-MM-dd");
    },
  }
};
</script>
<style lang="less" scoped>
  .data-static {
	height: 100%;
	.select-box {
		display: flex;
		margin-bottom: 30px;
		align-content: center;
		// text-align: center;
		div {
			width: 44%;
			padding: 0 10px;
			span {
				font-size: 22px;
    		font-weight: 700;
				color: #222;
			}
		}
	}
    .top {
		width: 100%;
		height: 400px;
		display: flex;
		justify-content: space-between;
      .top-left {
		width: 40%;
		height: 100%;
		.top-bot {
			width: 100%;
			height: ~"calc(100% - 60px)";
			display: flex;
			justify-content: space-between;
			align-items: center;
			.left {
				width: 45%;
				height: 100%;
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				.list {
					width: 100%;
					height: 48%;
					background-color: green;
					display: flex;
					align-items: center;
					justify-content: center;
					flex-wrap: wrap;
					border-radius: 10px;
					padding: 30px 0;
					box-sizing: border-box;
					p {
						width: 100%;
						color: #fff;
						text-align: center;
						font-size: 22px;
						font-weight: 700;
					}
				}
				.list:last-child {
					background-color: #409eff;
				}
			}
			.right {
				width: 54%;
				height: 100%;
				background-color: orange;
				border-radius: 10px;
				.list {
					width: 100%;
					height: 100%;
					display: flex;
					justify-content: center;
					align-items: center;
					flex-wrap: wrap;
					padding: 50px 0;
					box-sizing: border-box;
					p {
						width: 100%;
						text-align: center;
						color: #fff;
						font-size: 24px;
						font-weight: 700;
					}
				}
			}
		}
      }
	  .top-right {
		  width: 60%;
		  height: 100%;
	  }
    }
	.bottom {
		margin-top: 50px;
		display: flex;
		justify-content: space-between;
		.left {
			width: 48%;
			.til {
				height: 50px;
				line-height: 50px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 22px;
				font-weight: 700;
				i {
					font-size: 16px;
					font-weight: 400;
				}
			}
		}
		.right {
			width: 49%;
			.til {
				height: 50px;
				line-height: 50px;
				display: flex;
				justify-content: space-between;
				align-items: center;
				font-size: 22px;
				font-weight: 700;

			}
		}
	}
  }
</style>
